import { render, staticRenderFns } from "./Approver.vue?vue&type=template&id=25e555ce&scoped=true"
import script from "./Approver.vue?vue&type=script&lang=js"
export * from "./Approver.vue?vue&type=script&lang=js"
import style0 from "./Approver.vue?vue&type=style&index=0&id=25e555ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e555ce",
  null
  
)

export default component.exports